/**
 * Api errors that can be reported by the SharedRecording controller
 */
export var SharedRecordingErrorCode;
(function (SharedRecordingErrorCode) {
    /**
     * Requested hearing segments for a recording do not overlap with its recording segments
     */
    SharedRecordingErrorCode["RecordingDoesNotHaveRequestedTimecodes"] = "shared-recording/RecordingDoesNotHaveRequestedTimecodes";
})(SharedRecordingErrorCode || (SharedRecordingErrorCode = {}));
